import axios from 'axios';

export const chatService = {
    getChatsService: () => axios.get(`/chats`, { auth: true }),

    getChatUsersService: (params) => axios.get(`/chats/users`, { auth: true, params: params }),

    createChatService: (body) => axios.post(`/chats`, body, { auth: true }),

    getMessagesService: (chatId, params) => axios.get(`/chats/${chatId}/messages`, { auth: true, params: params }),

    sendMessageService: (chatId, body) => axios.post(`/chats/${chatId}/messages`, body, { auth: true }),

    editMessageService: (messageId, body) => axios.patch(`/chats/messages/${messageId}`, body, { auth: true }),

    deleteMessageService: (messageId) => axios.delete(`/chats/messages/${messageId}`, { auth: true }),

    markReadService: (chatId) => axios.post(`/chats/${chatId}/read`, null, { auth: true }),

    markMessageReadService: (messageId) => axios.post(`/chats/messages/${messageId}/read`, null, { auth: true }),

    deleteChatService: (chatId) => axios.delete(`/chats/${chatId}`, { auth: true }),

    removeChatMemberService: (chatId, userId) => axios.delete(`/chats/${chatId}/participants/${userId}`, { auth: true }),

    addChatMembersService: (chatId, participants) => axios.post(`/chats/${chatId}/participants`, { participants }, { auth: true }),

    muteChatService: (chatId, muted) => axios.patch(`/chats/${chatId}/mute`, { muted }, { auth: true }),

    searchMessagesService: (chatId, params) => axios.get(`/chats/${chatId}/messages/search`, { auth: true, params: params }),
};
